module.exports = __webpack_public_path__ + "img/correct_person.2aabc7bd.svg";